import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

/**
 * The VM-reinstall report's columns, in render order. Labels match the table headers exactly.
 *
 * Locked: `vm` says which machine the row is about, and `actions` is where the row is removed.
 * `finishedAt` starts hidden — the plan and the status answer "does this count against the
 * limit", which is what the screen is opened for.
 */
export const RESOURCE_REINSTALL_COLUMNS = [
  { id: "index", label: "STT" },
  { id: "vm", label: "VM", locked: true },
  { id: "ip", label: "IP" },
  { id: "plan", label: "Plan" },
  { id: "status", label: "Status" },
  { id: "requestedBy", label: "Requested By" },
  { id: "tenant", label: "Tenant" },
  { id: "requestedAt", label: "Requested At" },
  { id: "finishedAt", label: "Finished At", hiddenByDefault: true },
  { id: "actions", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type ResourceReinstallColumnId =
  (typeof RESOURCE_REINSTALL_COLUMNS)[number]["id"];

export const useResourceReinstallColumnsStore =
  createColumnVisibilityStore<ResourceReinstallColumnId>({
    name: "admin.resourceReinstalls.columns",
    columns: RESOURCE_REINSTALL_COLUMNS,
  });
